import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Navbar } from "../Navbar/Navbar";
import { Footer } from "../Home Page/Footer";
import "../Legal/Disclaimer.css"; // Reuse the simple styling

const BecomePosp = () => {
    const history = useHistory();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleProceed = () => {
        history.push("/OtpLogin");
    };

    return (
        <>
            <Navbar />
            <div className="container-fluid disclaimer-page posp-layout-padding">
                <div className="row">
                    <div className="col-12">
                        <h1>Be a POSP with Vibe</h1>

                        <p><strong>Are you POSP?</strong></p>
                        <p>
                            At Vibe, Point Of Sales Person (POSP) gives self-sustainability for an individual by allowing him to design own source of income and live independently being an agent.
                            At Vibe, we give you the flexibility to engage and expand your growth without any limitation. Be a POSP today.
                        </p>

                        <p><strong>What is POSP Person?</strong></p>
                        <p>
                            A Point of Sales Person (POSP) is a mediator between the customer and the company. The Insurance Regulatory and Development Authority of India (IRDAI) ensures its root to diversify the growth of all insurance-related activities, hence POSP.
                            A POSP who wish to dive in the depts of being an advisor or an agent is most greeted and is permitted to go ahead and expand their level of growth by introducing insurance policies to the customers.
                            Today’s enlarging market has inculcated the culture to buy an insurance policy as the necessity to secure oneself and the loved ones, which gives the agent the advantage to be a POSP.
                            Hence you are not far away to be the next POSP.
                        </p>

                        <p><strong>Eligibility criteria to become a POSP for VIBE</strong></p>
                        <p>
                            If you have to urge to be a POSP you need to qualify the criteria set by IRDAI regulations to appoint an Insurance Agent.
                        </p>
                        <p>
                            • Your maturity and thinking level should be that of 18 years and above. <br />
                            • Must complete your basic higher school Education. <br />
                            • You need to have documents like PAN card & AADHAR card, proof of identification and address, recent photographs and essential exam certificate. <br />
                            • Attend a verified training to be a POSP, organized by the company and pass the test conducted by VIBE guidelines. <br />
                            • Own an approved certification by VIBE post-training.
                        </p>

                        <div className="text-center mt-5 mb-5">
                            <button
                                className="btn btn-primary btn-lg px-5 py-3 shadow"
                                onClick={handleProceed}
                                style={{ backgroundColor: "#273592", borderColor: "#273592", borderRadius: "8px", fontWeight: "600" }}
                            >
                                Proceed to Login / Register
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default BecomePosp;
